import {Component, OnInit} from '@angular/core';
import {AbstractComponent} from "../abstract.component";
import {DatePipe} from '@angular/common';

@Component({
  selector: 'app-series-table',
  templateUrl: './series-table.component.html',
  styleUrls: ['./series-table.component.scss'],
  providers: [DatePipe]
})
export class SeriesTableComponent extends AbstractComponent implements OnInit {

  constructor() {
    super();
  }

  ngOnInit(): void {
  }

}
